import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { useHighFrequencyRefreshQuery } from '../../../queryDefaults/baseQueries/useHighFrequencyRefreshQuery';
import { Collaborator, ICollaborator } from '../Collaborator.ts';
import { CollaboratorApi } from '../../../apis/CollaboratorApi/CollaboratorApi.ts';
import { useIdFromRoute } from '../../../hooks/useIdFromRoute.tsx';

export function useGetCollaboratorById() {
    const id = useIdFromRoute();
    return useHighFrequencyRefreshQuery({
        queryKey: [QueryKeys.collaborator, id],
        queryFn: async () => {
            const result: ICollaborator = await CollaboratorApi.getCollaboratorById(id!);
            return new Collaborator(result);
        },
        enabled: !!id,
    });
}
